// Utilidades para cálculos de precios
// NOTA: Los precios ya vienen multiplicados por pack_quantity desde el backend

/**
 * Función principal para determinar el precio a mostrar
 * Usa directamente los precios que vienen del backend (ya multiplicados por pack_quantity)
 * @param {Object} product - Objeto del producto
 * @returns {number} - Precio calculado
 */
export const getDisplayPrice = (product) => {
    // Usar directamente los precios que vienen del backend
    // El backend ya se encarga de multiplicar por pack_quantity
    return product.sale_price ? parseFloat(product.sale_price) : parseFloat(product.price);
};

/**
 * Indica si el producto tiene un descuento real (precio oferta válido y
 * menor al precio regular). Si false, no se debe pintar el badge -X% ni
 * el precio regular tachado.
 * @param {Object} product
 * @returns {boolean}
 */
export const hasDiscount = (product) => {
    const sale = parseFloat(product?.sale_price || 0);
    const price = parseFloat(product?.price || 0);
    return sale > 0 && price > 0 && sale < price;
};

/**
 * Formatea un precio para mostrar
 * @param {number} price - Precio a formatear
 * @returns {string} - Precio formateado
 */
export const formattedPrice = (price) => new Intl.NumberFormat('de-DE').format(price);
